import { Button, Modal, Textarea } from '@orobix/orobix-fe-components'
import { useMutation } from '@tanstack/react-query'
import { Formik, FormikErrors } from 'formik'
import { useTranslation } from 'react-i18next'

import { ErrorText } from '../../components/ErrorText/ErrorText'
import { update } from '../../utils/api'
import { Dataset } from './DatasetsList'

type FormValues = {
  notes: string
}

type DatasetsNotesUpdateProps = {
  onClose: () => void
  onSuccess: () => void
  datasetId: number
  initialValues?: FormValues
  setNotes: React.Dispatch<React.SetStateAction<string>>
}

const DatasetsNotesUpdate = ({
  onClose,
  onSuccess,
  datasetId,
  initialValues = { notes: '' },
  setNotes,
}: DatasetsNotesUpdateProps) => {
  const { t } = useTranslation()

  const { mutate, isLoading, isError } = useMutation(
    (values: FormValues) => update<Dataset>(`/dataset/${datasetId}/`, values),
    { onSuccess, useErrorBoundary: false }
  )

  return (
    <Formik
      initialValues={initialValues}
      validate={(values) => {
        const errors: FormikErrors<{ [field: string]: string }> = {}
        return errors
      }}
      onSubmit={(values, { setSubmitting }) => {
        mutate(values)
        setSubmitting(false)
        setNotes(values.notes)
      }}
    >
      {({
        values,
        errors,
        touched,
        handleBlur,
        handleSubmit,
        isSubmitting,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit}>
          <Modal
            size="md"
            onCloseRequest={onClose}
            title={t('Dataset notes')}
            footer={
              <Button
                label={t('Save')}
                type="action"
                disabled={isSubmitting}
                loading={isLoading}
              />
            }
          >
            <Textarea
              name="notes"
              id="dataset-notes"
              type="text"
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                setFieldValue('notes', e.target.value)
              }
              onBlur={handleBlur}
              value={values.notes}
              error={!!(errors.notes && touched.notes)}
              errorMessage={errors.notes}
              disabled={isSubmitting}
            />

            {isError && <ErrorText />}
          </Modal>
        </form>
      )}
    </Formik>
  )
}

export default DatasetsNotesUpdate
